import axios from "axios";
import JwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import { LOGOUT } from "@/core/services/store/auth.module";
import Vue from "vue";
import { ir } from "./check_domain_ir";

Vue.prototype.$paymak_land = ir(process.env.VUE_APP_PayamakLandURL);
let payamak_land = ir(process.env.VUE_APP_PayamakLandURL);
let coreland = ir(process.env.VUE_APP_CoreLandUrl);
let coreSecret = process.env.VUE_APP_CORE_SECRET;
let robotLandBack = ir("https://robot-api.terminalads.com/api"); // ir(process.env.VUE_APP_RobatLandBack);
let infolandBack = ir(process.env.VUE_APP_Infoland);

let coreWalelt = ir(process.env.VUE_APP_WALLET_URL);
const axiosApi = axios.create({
  // baseURL: process.env.VUE_APP_PayamakLandURL,
  baseURL: "https://t7r.ir/api",
  timeout: 15000,
  headers: {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});
Vue.prototype.$api = axiosApi;

function checkToken(token) {
  axios
    .get(`${this.$sarveLand}/api/user`, {
      headers: {
        secret: coreSecret,
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem("user_info", JSON.stringify(res.data));
        // this.$router.push({name: 'dashboard'})
      }
    })
    .catch(({ response }) => {
      if (response.status === 401) {
        this.$store
          .dispatch(LOGOUT)
          .then(() => window.location.replace(`${this.$sarveLandFront}`));
      }
    });
}

function saveToken(token) {
  localStorage.setItem("id_token", token);
  this.$router.push("/dashboard");
}

function header() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function robotHeader() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    // "Content-Type": "application/json",
  };
}

function coreHeader() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    // secret: coreSecret,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function coreWalletHeader() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  };
}

function requestApiGet(uri, queries = {}, serializer = null) {
  return axios.get(`${payamak_land + "/api"}/${uri}`, {
    headers: header(),
    params: queries,
    paramsSerializer: serializer,
  });
}

function request_ApiGet(uri, queries = {}) {
  return axios.get(`${coreland + "/api"}/${uri}`, {
    headers: header(),
    params: queries,
  });
}

function requestApiGetCore(uri, queries = {}) {
  return axios.get(`${coreland + "/api"}/${uri}`, {
    headers: coreHeader(),
    params: queries,
  });
}

function requestApiPostCore(uri, data = {}) {
  return axios.post(`${coreland + "/api"}/${uri}`, data, {
    headers: coreHeader(),
  });
}

function requestApiPost(uri, data = {}) {
  return axios.post(`${payamak_land + "/api"}/${uri}`, data, {
    headers: header(),
  });
}

function requestApiPostLogin(uri, data = {}) {
  return axios.post(`${payamak_land + "/api"}/${uri}`, data);
}

function requestApiPut(uri, data = {}, queries = {}) {
  return axios.put(`${payamak_land + "/api"}/${uri}`, data, {
    headers: header(),
    params: queries,
  });
}

function requestApiDelete(uri, queries = {}) {
  return axios.delete(`${payamak_land + "/api"}/${uri}`, {
    headers: header(),
    params: queries,
  });
}

function requestApiGetRobot(uri, queries = {}) {
  return axios.get(`${robotLandBack}/${uri}`, {
    headers: robotHeader(),
    params: queries,
  });
}

function requestApiPostRobot(uri, data = {}, queries = {}, config = {}) {
  return axios.post(`${robotLandBack}/${uri}`, data, {
    ...config,
    params: queries,
    headers: {
      ...robotHeader(),
      ...(config.headers || {}),
    },
  });
}

function requestApiGetInfo(uri, queries = {}) {
  return axios.get(`${infolandBack + "/api"}/${uri}`, {
    headers: coreHeader(),
    params: queries,
  });
}

function requestApiGetWallet(uri, queries = {}) {
  return axios.get(`${coreWalelt + "/api"}/${uri}`, {
    headers: coreWalletHeader(),
    params: queries,
  });
}

function requestApiPostWallet(uri, data = {}) {
  return axios.post(`${coreWalelt + "/api"}/${uri}`, data, {
    headers: coreWalletHeader(),
  });
}

export default {
  axios,
  saveToken,
  checkToken,
  robotHeader,
  header,
  coreHeader,
  coreWalletHeader,
  requestApiGet,
  requestApiPost,
  requestApiPostCore,
  requestApiPostLogin,
  requestApiPut,
  requestApiDelete,
  request_ApiGet,
  requestApiGetCore,
  requestApiGetRobot,
  requestApiPostRobot,
  requestApiGetInfo,
  requestApiGetWallet,
  requestApiPostWallet,
};
